<template>
	<div>
		<h1>Editeur de variantes</h1>

        <b-form inline>
            <b-input-group prepend="Nom">
                <b-form-input v-model="name"></b-form-input>
            </b-input-group>
            <b-input-group prepend="Version">
                <b-form-input v-model="version"></b-form-input>
            </b-input-group>
            <b-button v-b-modal="'modal' + id">Charger</b-button>
            <b-button @click="save_db" :disabled="!version || !name"
                ><i class="fas fa-save"></i
            ></b-button>
            <b-button v-b-modal="'modal_file' + id">Fichier</b-button>
            <b-button v-b-modal="'modal_rename' + id">Renommer</b-button>
        </b-form>

        <b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
            <span>Nom</span>
            <v-select
                v-model="load_name"
                :options="list_names"></v-select>
            <span>Version</span>
            <v-select
                v-model="load_version"
                :options="versions"></v-select>
        </b-modal>

        <b-modal
            :hide-footer="true"
            :id="'modal_file' + id"
            title="Fichier">
            <b-file
                accept=".json"
                @change="load_file"
                placeholder="charger (fichier)"></b-file>
            <br /><br />
            <b-button @click="save">sauvergarder (fichier)</b-button>
        </b-modal>

        <b-modal
            :hide-footer="true"
            :id="'modal_rename' + id"
            title="Renommer">
            <p>Nouveau nom</p>
            <b-input v-model="new_name"></b-input>
            <br />
            <b-button @click="rename">Rennomer</b-button>
        </b-modal>

        <p>Données</p>

        <edit_tabulator @update="import_data" ref="start_tabulator"></edit_tabulator>

        <p>
            Colonne de désignation
            <v-select v-model="column" :options="columns"></v-select>
        </p>

        <b-button variant="primary" @click="generate">Générer</b-button>

        <div v-show="data && data.length > 0">

            <div>
                Colonnes affichées
                <br />
                <div class="tag" v-for="(column, idx) in columns_visible" :key="'c'+idx">
                    {{ column }} <b-button style="color:white" variant="link" @click="columns_visible.splice(idx, 1)"><i class="fas fa-times"></i></b-button>
                </div>
                <div style="margin:5px"></div>
                <v-select @option:selected="setColumn" v-model="column_visible" :options="columns"></v-select>
                <div style="margin:5px"></div>
            </div>

            <p>
                <b-checkbox style="display:inline" v-model="view_names_validate"></b-checkbox> Voir les éléments validés 
            </p>

            <p>Appuyez sur e pour paser en mode edition.</p>

            <div v-for="(name, idx) in sortedNames" :key="idx">
                <div v-show="view_names_validate || !names_validate.includes(name)">
                    <b-button v-if="!names_validate.includes(name)" variant="link" @click="check(name, true)"><i class="fa fa-check"></i></b-button>
                    <b-button v-else variant="link" @click="check(name, false)"><i class="fas fa-times"></i></b-button>
                    <b-button v-show="name" variant="link" @click="addBase(name, idx)">+ base</b-button>
                    <b-button v-show="name" variant="link" @click="lessBase(name, idx)">- base</b-button>
                    <b-button v-show="name" variant="link" @click="removeBase(name, idx)">supprimer base</b-button>
                    <b-button variant="link" @click="setRegroup(name)"><i class="fas fa-cogs"> </i></b-button>
                    <b-form-input style="display:inline; width: 500px" v-if="edit" @change="updateBase(name, $event, idx)" :value="name" size="sm" />
                    <b v-else>{{ name ? name : "Pas de variantes" }}</b>
                    <b-table striped hover :items="filteredRows(variants[name])" :fields="name ? [column_variant].concat(columns_visible) : [column].concat(columns_visible)">
                        <template v-slot:[`cell(${column_variant})`]="{ item }">
                            <div v-if="edit" class="d-flex align-items-center">
                                <b-button style="white-space: nowrap;"  class="me-2" variant="link" @click="removeVariant(item[column_variant], name)">Enlever variant</b-button>
                                <b-form-input class="flex-grow-1"  @change="updateVariant(item)" v-model="item[column_variant]" size="sm" />
                            </div>
                            <span v-else>{{ item[column_variant] }}</span>
                        </template>
                    </b-table>
                </div>
            </div>

            <b-modal :hide-footer="true" :id="'modal'" title="Regrouper ou enlever" size="xl">
                Base <b-button variant="link" @click="remove_word_base()">- base</b-button>
                <b-input :list="'my-list'" v-model="base"></b-input>
                <datalist :id="'my-list'">
                    <option v-for="(name, idx) in names" :key="idx">{{ name }}</option>
                </datalist>

                Variantes
                <div :style="names_validate.includes(name) ? 'color:green' : ''" v-for="(name, idx) in names.filter((name) => name.startsWith(base))" :key="idx">
                    {{ name }}
                </div>

                <hr />

                Lignes
                <b-table striped hover :items="data.filter((line) => line[column].toLowerCase().startsWith(base.toLowerCase()))" :fields="[column, column_base, column_variant]">
                </b-table>

                <b-button @click="regroup()">Regrouper</b-button>&nbsp;
                <b-button @click="remove()">Supprimer variantes</b-button>&nbsp;
                <b-button @click="$bvModal.hide('modal')">Fermer</b-button>
            </b-modal>

            <hr />
            Export

            <br />

            <b-button variant="primary" @click="generate_export(true)"><i class="fas fa-sync-alt"></i> données validées</b-button>&nbsp;
            <b-button variant="primary" @click="generate_export(false)"><i class="fas fa-sync-alt"></i> données non validées</b-button>&nbsp;
            <b-button variant="primary" @click="generate_export(null)"><i class="fas fa-sync-alt"></i> toutes les données</b-button>

            <br /><br />

            <edit_tabulator :extern_file="false" ref="export_tabulator"></edit_tabulator>
        </div>
	</div>
</template>

<script>
	import store from "../store";
	import users from "../services/users.js";
	import utils from "../services/utils.js";
	import client from "../services/client.js";
	import element from "../services/library.js";
	import edit_tabulator from "../components/edit_tabulator.vue";

    import uniqueId from "lodash.uniqueid";

    var clone = require("clone");

	export default {
		name: "variants",
        components: {
            edit_tabulator
        },
		data() {
			return {
                id: uniqueId(),
                type: "variants",
				name: "",
				new_name: "",
				list_names: [],
				versions: [],
				version: "",
				load_name: "",
				load_version: "",

                columns: [],
                column: "",
                column_base: "base",
                column_variant: "variant",
                column_status: "statut",
                data: [],
                variants: {},
                names: [],
                names_validate: [],
                view_names_validate: false,
                base: "",
                columns_visible: [],
                column_visible: "",
                edit: false,
                old_name: ""
			};
		},
        computed: {
            sortedNames() {
                return [...this.names].sort((a, b) =>
                    a.toLowerCase().localeCompare(b.toLowerCase())
                );
            }
        },
		watch: {
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await element.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {
            originalIndexFromSortedIndex(sortedIndex) {
                const name = this.sortedNames[sortedIndex];
                return this.names.indexOf(name);
            },
            updateBase(base, new_base, idx)
            {
                idx = this.originalIndexFromSortedIndex(idx);

                for (var i = 0; i < this.variants[base].length; i++)
                {
                    this.data[this.variants[base][i]][this.column] = new_base + " " + this.data[this.variants[base][i]][this.column_variant];
                    this.data[this.variants[base][i]][this.column_base] = new_base;
                }
                if (this.variants[new_base])
                {
                    if (this.names_validate.indexOf(new_base) >= 0)
                    {
                        this.names_validate.splice(this.names_validate.indexOf(new_base), 1);
                        for (var i = 0; i < this.variants[new_base].length; i++)
                        {
                            this.data[this.variants[new_base][i]][this.column_status] = "";
                        }
                    }
                    this.variants[new_base] = this.variants[base].concat(this.variants[new_base]);
                }
                else
                    this.variants[new_base] = this.variants[base];
                delete this.variants[base];
                if (!this.names.includes(new_base))
                    this.$set(this.names, idx, new_base);
                else
                    this.$delete(this.names, idx);
            },
            onKeyPress(event) {
                const tag = event.target.tagName.toLowerCase();
                if (['input', 'textarea', 'select'].includes(tag)) return;

                if (event.key === 'e' || event.key === 'E') {
                    // Action quand 'e' est pressée
                    this.edit = !this.edit;
                    // ... ton action ici
                }
            },
            async updateVariant(item)
            {
                item[this.column] = item[this.column_base] + item[this.column_variant];
            },
			async rename() {
				console.log("rename");
				await element.rename(
					this.type,
					this.name,
					this.new_name
				);
				this.name = this.new_name;
				this.save_db();
			},
			async set_name() {
				var names = await element.getby_production(this.type);

                console.log(names)

				names = names.element;

				this.list_names = [];
				for (var i = 0; i < names.length; i++) {
					this.list_names.push(names[i].name);
				}
			},
			async save_db() {
				var data = await this.save(false);

				await element.save(
					this.name,
					this.version,
					data,
					this.type
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement en base effectué",
					type: "success",
				});
			},
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await element.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name = this.load_name;
				this.version = this.load_version;
				await this.load(result);
				document.body.style.cursor = "default";
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);
						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
            async save(file = false)
            {
                var obj = {
                    import_data: this.$refs.start_tabulator.get_data(),
                    columns: this.columns,
                    column: this.column,
                    column_base: this.column_base,
                    column_variant: this.column_variant,
                    data: this.data,
                    variants: this.variants,
                    names: this.names,
                    names_validate: this.names_validate,
                    view_names_validate: this.view_names_validate,
                    base: this.base,
                    columns_visible: this.columns_visible,
                    column_visible: this.column_visible,
                    column_status: this.column_status
                }

                if (file)
					utils.saveToFile(
						JSON.stringify(obj),
						(this.name || "variants") + ".json"
					);
				else 
                    return obj;
            },
            async load(data)
            {
                this.$refs.start_tabulator.set_data(data.import_data);
                this.columns = data.columns;
                this.column = data.column;
                this.column_base = data.column_base;
                this.column_variant = data.column_variant;
                this.data = data.data;
                this.variants = data.variants;
                this.names = data.names;
                this.names_validate = data.names_validate;
                this.view_names_validate = data.view_names_validate;
                this.base = data.base;
                this.columns_visible = data.columns_visible;
                this.column_visible = data.column_visible;
                this.column_status = data.column_status || "statut";
            },
            generate_export(validate)
            {
                var data = clone(this.data);

                if (validate === true)
                    data = data.filter((line) => line[this.column_status])
                if (validate === false)
                    data = data.filter((line) => !line[this.column_status])

                this.$refs.export_tabulator.set_data(data);
            },
            check(name, state)
            {
                console.log("-" + name + "-");
                console.log(state);
                console.log(this.names_validate)
                if (state == false)
                {
                    this.names_validate.splice(this.names_validate.indexOf(name), 1);
                    for (var i = 0; i < this.variants[name].length; i++)
                    {
                        this.data[this.variants[name][i]][this.column_status] = "";
                    }
                }
                else if (!this.names_validate.includes(name))
                {
                    this.names_validate.push(name);
                    for (var i = 0; i < this.variants[name].length; i++)
                    {
                        this.data[this.variants[name][i]][this.column_status] = "validé";
                    }
                }
            },
            setColumn()
            {
                if (this.columns_visible && !this.columns_visible.includes(this.column_visible))
                {
                    this.columns_visible.push(this.column_visible);
                }
                this.column_visible = "";
            },
            remove_word_base()
            {
                var base = this.base;
                base = base.split(" ");
                base.pop();
                this.base = base.join(" ");
            },
            remove()
            {
                if (!this.base)
                    return;

                var names = this.names.filter((name) => name.startsWith(this.base));

                if (!this.variants[""])
                {
                    this.variants[""] = [];
                    this.names.unshift("");
                }

                for (var i = 0; i < names.length; i++)
                {
                    var base = names[i];
                    for (var i = 0; i < this.variants[base].length; i++)
                    {
                        this.data[this.variants[base][i]][this.column_base] = "";
                        this.data[this.variants[base][i]][this.column_variant] = "";
                        this.variants[""].push(this.variants[base][i]);
                    }
                    delete this.variants[base]
                    this.names.splice(this.names.indexOf(base), 1); 
                }

                this.$bvModal.hide('modal');
            },
            regroup()
            {
                if (!this.base)
                    return;

                var names = this.names;
                if (names.indexOf(this.base) >= 0)
                {
                    if (this.names_validate.indexOf(this.base) >= 0)
                    {
                        this.names_validate.splice(this.names_validate.indexOf(this.base), 1);
                        for (var i = 0; i < this.variants[this.base].length; i++)
                        {
                            this.data[this.variants[this.base][i]][this.column_status] = "";
                        }
                    }
                    names.splice(names.indexOf(this.base), 1);
                }
                else
                    this.variants[this.base] = [];

                var r = new RegExp(this.base, i)
                for (var j = 0; j < names.length; j++)
                {
                    var base = names[j];
                    for (var i = 0; i < this.variants[base].length; i++)
                    {
                        if (this.data[this.variants[base][i]][this.column].toLocaleLowerCase().startsWith(this.base.toLocaleLowerCase()))
                        {
                            this.data[this.variants[base][i]][this.column_base] = this.base.trim();
                            this.data[this.variants[base][i]][this.column_variant] = this.data[this.variants[base][i]][this.column].replace(r, "").trim();
                            this.variants[this.base].push(this.variants[base][i]);
                            this.variants[base].splice(i, 1);
                            i--;
                        }
                    }
                }
                this.names.push(this.base);

                for (var i = 0; i < this.names.length; i++)
                {
                    if (this.names[i] && this.variants[this.names[i]].length <= 1)
                    {
                        if (this.variants[this.names[i]].length == 1)
                        {
                            this.data[this.variants[this.names[i]][0]][this.column_base] = "";
                            this.data[this.variants[this.names[i]][0]][this.column_variant] = "";

                            if (!this.variants[""])
                            {
                                this.variants[""] = [];
                                this.names.unshift("");
                            }
                            this.variants[""].push(this.variants[this.names[i]][0]);
                        }
                        delete this.variants[this.names[i]];
                        this.names.splice(i, 1);
                        i--;
                    }
                }

                this.$bvModal.hide('modal');
            },
            setRegroup(base)
            {
                this.base = base;
                this.$bvModal.show("modal")
            },
            removeVariant(name_variant, base)
            {
                for (var i = 0; i < this.variants[base].length; i++)
                {
                    if (this.data[this.variants[base][i]][this.column_variant] == name_variant)
                    {
                        this.data[this.variants[base][i]][this.column_variant] = "";
                        this.data[this.variants[base][i]][this.column_variant] = "";                       
                        this.variants[""].push(this.variants[base][i]);
                        this.variants[base].splice(i, 1);
                        i--;
                    }
                }

                for (var i = 0; i < this.names.length; i++)
                {
                    if (this.names[i] && this.variants[this.names[i]] && this.variants[this.names[i]].length <= 1)
                    {
                        if (this.variants[this.names[i]].length == 1)
                        {
                            this.data[this.variants[this.names[i]][0]][this.column_base] = "";
                            this.data[this.variants[this.names[i]][0]][this.column_variant] = "";

                            if (!this.variants[""])
                            {
                                this.variants[""] = [];
                                this.names.unshift("");
                            }
                            this.variants[""].push(this.variants[this.names[i]][0]);
                        }
                        delete this.variants[this.names[i]];
                        this.names.splice(i, 1);
                        i--;
                    }
                }
            },
            removeBase(base, idx)
            {
                idx = this.originalIndexFromSortedIndex(idx);

                console.log(base)
                console.log(idx)
                if (!this.variants[""])
                {
                    this.variants[""] = [];
                    this.names.unshift("");
                }
                if (this.variants[base])
                {
                    for (var i = 0; i < this.variants[base].length; i++)
                    {
                        this.data[this.variants[base][i]][this.column_base] = "";
                        this.data[this.variants[base][i]][this.column_variant] = "";
                        this.variants[""].push(this.variants[base][i]);
                    }
                    delete this.variants[base];
                    this.names.splice(idx, 1); 
                }
            },
            addBase(base, idx)
            {                
                idx = this.originalIndexFromSortedIndex(idx);

                var names = [];
                var variants = [];
                if (this.variants[base].length > 0)
                   variants = this.data[this.variants[base][0]][this.column_variant].split(" ");
                var new_base = base + " " + variants.shift();
                for (var i = 0; i < this.variants[base].length; i++)
                {
                    this.data[this.variants[base][i]][this.column_base] += " " + new_base;
                    this.data[this.variants[base][i]][this.column_variant] = this.data[this.variants[base][i]][this.column_variant].split(" ");
                    this.data[this.variants[base][i]][this.column_variant].shift()
                    this.data[this.variants[base][i]][this.column_variant] = this.data[this.variants[base][i]][this.column_variant].join(" ");
                    if (!names.includes(new_base) && !this.names.includes(new_base))
                        names.push(new_base);
                    if (!this.variants[new_base])
                    {
                        this.variants[new_base] = [];
                    }
                    else
                    {
                        if (this.names_validate.indexOf(base) >= 0)
                        {   
                            this.names_validate.splice(this.names_validate.indexOf(base), 1);
                            for (var i = 0; i < this.variants[base].length; i++)
                            {
                                this.data[this.variants[base][i]][this.column_status] = "";
                            }
                        }
                    }
                    this.variants[new_base].push(this.variants[base][i]);
                }
                this.names.splice(idx, 1, ...names);
                if (!names.includes(base))
                    this.variants[base] = [];

                for (var i = 0; i < this.names.length; i++)
                {
                    if (this.names[i] && this.variants[this.names[i]] && this.variants[this.names[i]].length <= 1)
                    {
                        if (this.variants[this.names[i]].length == 1)
                        {
                            this.data[this.variants[this.names[i]][0]][this.column_base] = "";
                            this.data[this.variants[this.names[i]][0]][this.column_variant] = "";

                            if (!this.variants[""])
                            {
                                this.variants[""] = [];
                                this.names.unshift("");
                            }
                            this.variants[""].push(this.variants[this.names[i]][0]);
                        }
                        delete this.variants[this.names[i]];
                        this.names.splice(i, 1);
                        i--;
                    }
                }
            },
            lessBase(base, idx)
            {
                idx = this.originalIndexFromSortedIndex(idx);
                
                if (!base)
                {
                    this.$notify({
                        group: "info",
                        title: "Base vide",
                        type: "warning",
                    });

                    return;
                }
                var names = base.split(" ");
                var name = names.pop();
                var new_base = names.join(" ");

                for (var i = 0; i < this.variants[base].length; i++)
                {
                    this.data[this.variants[base][i]][this.column_variant] = name + " " + this.data[this.variants[base][i]][this.column_variant];
                    this.data[this.variants[base][i]][this.column_base] = new_base;
                }
                if (this.variants[new_base])
                {
                    if (this.names_validate.indexOf(new_base) >= 0)
                    {
                        this.names_validate.splice(this.names_validate.indexOf(new_base), 1);
                        for (var i = 0; i < this.variants[new_base].length; i++)
                        {
                            this.data[this.variants[new_base][i]][this.column_status] = "";
                        }
                    }
                    this.variants[new_base] = this.variants[base].concat(this.variants[new_base]);
                }
                else
                    this.variants[new_base] = this.variants[base];
                delete this.variants[base];
                if (!this.names.includes(new_base))
                    this.$set(this.names, idx, new_base);
                else
                    this.$delete(this.names, idx);
            },
            filteredRows(indexes = []) {
                return indexes
                    .map(i => this.data[i])
                    .filter(row => row !== undefined);
            },
            set_variants()
            {
                var columns = [];

                //columns.push(this.column);
                //columns.push(this.column_base);
                //columns.push(this.column_variant);

                for (var i = 0; i < this.columns.length; i++)
                {
                    if (!columns.includes(this.columns[i]) && this.columns[i] != this.column_base && this.columns[i] != this.column_variant)
                        columns.push(this.columns[i]);
                }

                this.variants = {"": []};
                this.names = [""];

                for (var i = 0; i < this.data.length; i++)
                {
                    if (!this.variants[this.data[i][this.column_base]])
                    {
                        this.variants[this.data[i][this.column_base]] = [];
                        this.names.push(this.data[i].base);
                    }
                    this.variants[this.data[i].base].push(i);
                }

                this.columns = columns;
            },
            import_data()
            {
                var data = this.$refs.start_tabulator.get_data();

                this.columns = Object.keys(data[0])

                for (var i = 0; i < this.columns.length; i++)
                {
                    if (this.columns[i] == "Désignation")
                        this.column = this.columns[i]                    
                }

                if (this.column && this.columns.includes(this.column_base) && this.columns.includes(this.column_variant))
                {
                    this.data = data;
                    this.set_variants();
                }
            },
            generate()
            {
                var data = this.$refs.start_tabulator.get_data();

                for (var i = 0; i < data.length; i++)
                {
                    data[i][this.column] = data[i][this.column].replace(/  +/gi, " ").trim();
                }
                data = data.sort((a, b) => {
                    if (a[this.column].toLowerCase() < b[this.column].toLowerCase()) return -1;
                    if (a[this.column].toLowerCase() > b[this.column].toLowerCase()) return 1;
                    return 0;
                });

                function isAllUppercase(str) {
                    return /^[A-Z0-9]+$/.test(str);
                }

                function isAllNumber(str) {
                    return /^[0-9,.]+$/.test(str);
                }

                var column = "Désignation";

                var prev_line = null;
                for (var i = 0; i < data.length; i++)
                {
                    data[i][this.column_status] = "";
                    data[i][this.column_base] = "";
                    data[i][this.column_variant] = "";

                    var line = data[i][column].split(" ");
                    if (prev_line)
                    {
                        var brand = true;
                        var variant = false;
                        var base = [];
                        for (var j = 0; j < line.length; j++)
                        {
                           if (brand && isAllUppercase(line[j]) && j < prev_line.length && line[j].toLowerCase() == prev_line[j].toLowerCase())
                                base.push(line[j]);
                            else if (j < prev_line.length && line[j].toLowerCase() == prev_line[j].toLowerCase())
                            {
                                brand = false;
                                base.push(line[j]);
                                variant = true;
                            }
                            else
                            {
                                if (!isAllUppercase(line[j]))
                                    brand = false;
                                break;
                            }
                        }
                        if (variant)
                        {
                            if (base.length > 2)
                            {
                                if (base[base.length - 1] == "x" && isAllNumber(base[base.length - 2]))
                                {
                                    base.pop();
                                    base.pop();
                                }
                            }
                            base = base.join(" ");
                            prev_line = null;
                            data[i].base = base.trim();
                            data[i].variant = data[i][column].replace(new RegExp(data[i].base, "i"), "").trim();
                            data[i - 1].base = base.trim();
                            data[i - 1].variant = data[i - 1][column].replace(new RegExp(data[i].base, "i"), "").trim();
                        }
                        else
                        {
                            prev_line = line;
                        }
                    }
                    else if (i > 0 && data[i - 1].base)
                    {
                        if (data[i][column].toLowerCase().includes(data[i - 1].base.toLowerCase()))
                        {
                            data[i].base = data[i - 1].base.trim();
                            data[i].variant = data[i][column].replace(new RegExp(data[i].base, "i"), "").trim();
                        }
                        else
                        {
                            prev_line = line;
                        }
                    }
                    else
                        prev_line = line;
                }

                this.data = data;
                this.set_variants();
            }
		},
        beforeDestroy() {
            window.removeEventListener('keydown', this.onKeyPress);
        },
		created: async function () {
			if (
				store.state.user.rules &&
				!store.state.user.rules.variants
			) {
				this.$router.push({ name: "profile" });
			}

            this.set_name();

            window.addEventListener('keydown', this.onKeyPress);
		},
	};
</script>

<style scoped>
.tag {
  display: inline-flex;
  align-items: center;
  background-color: #0256B2;
  color: white;
  border-radius: 6px;
  padding: 2px 6px;
  font-size: 12px;
  font-family: sans-serif;
  margin: 2px;
}

</style>
